import * as React from 'react';

import type { SurveyOption } from 'bundles/refund/common/types';

import 'css!./__styles__/RefundReasonMultipleChoiceContent';

type Props = {
  description: React.ReactNode;
  setAnswer: (answer: string) => void;
  reasons?: Array<SurveyOption> | null;
  surveyFooter?: JSX.Element;
};

class RefundReasonMultipleChoiceContent extends React.Component<Props> {
  handleSelect = (e: React.MouseEvent<HTMLButtonElement>): void => {
    this.props.setAnswer((e.target as HTMLButtonElement).value);
  };

  renderReason = ({ id, text }: SurveyOption) => {
    return (
      <button type="button" key={id} className="reason" value={id} onClick={this.handleSelect}>
        {text}
      </button>
    );
  };

  render() {
    const { description, reasons, surveyFooter } = this.props;

    if (!reasons) {
      return null;
    }

    return (
      <div className="rc-RefundReasonMultipleChoiceContent">
        <p className="subtitle">{description}</p>
        <div>{reasons.map(this.renderReason)}</div>
        {surveyFooter}
      </div>
    );
  }
}

export default RefundReasonMultipleChoiceContent;
